import { z } from 'zod';
export const RiskLevelEnum = z.enum([
    'low',
    'medium',
    'high',
    'critical'
]);
export const RiskTypeStatusSchema = z.object({
    status: z.enum([
        'clear',
        'alert'
    ])
});
export const RiskTypesSchema = z.object({
    chargebacks: RiskTypeStatusSchema.nullish(),
    contentFindings: RiskTypeStatusSchema.nullish(),
    reputational: RiskTypeStatusSchema.nullish(),
    transactionLaundering: RiskTypeStatusSchema.nullish(),
    legal: RiskTypeStatusSchema.nullish()
});
export const RiskAssessmentSchema = z.object({
    riskLevel: RiskLevelEnum.nullish(),
    riskTypes: RiskTypesSchema.nullish(),
    isAlert: z.boolean().nullish()
}).meta({
    id: 'RiskAssessment'
});

//# sourceMappingURL=risk-assessment.schema.js.map